import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { downloadReceiptPdf } from 'lib/helpers/pdf/download/download';

import Button from 'components/shared/Button/Button';
import { showAlert } from 'components/shared/Alert/Alert';

import ReceiptSendActions from './ReceiptSendActions';

const ReceiptActionButtons = ({
  transactionId,
  emailTransactionId = transactionId,
  appointmentId,
  token,
  channels,
  kioskDevice = false,
  isPatientSide = false
}) => {
  const navigate = useNavigate();
  const [isPrinting, setIsPrinting] = useState(false);

  const handlePrint = async () => {
    setIsPrinting(true);
    const opened = await downloadReceiptPdf({
      navigate,
      transactionId,
      appointmentId,
      token,
      print: true
    });
    setIsPrinting(false);
    if (!opened) {
      showAlert({
        title: "Couldn't generate the receipt PDF. Please try again.",
        color: 'danger'
      });
    }
  };

  return (
    <>
      <ReceiptSendActions
        transactionId={emailTransactionId}
        appointmentId={appointmentId}
        token={token}
        channels={channels}
        kioskDevice={kioskDevice}
        isPatientSide={isPatientSide}
        isDisabled={!emailTransactionId && !appointmentId}
      />
      {!kioskDevice && (
        <Button
          size="small"
          variant="link"
          color="neutral"
          iconSize={16}
          shade={700}
          iconShade={700}
          iconColor="neutral"
          text="Print"
          icon="printer-mono"
          onClick={handlePrint}
          isLoading={isPrinting}
        />
      )}
    </>
  );
};

export default ReceiptActionButtons;
